/**
 * Role-tone palette ported from designv2/src/data.jsx. UsersView's role-tag
 * pills and the future Members role chips both consume it. Adding a role to
 * the catalogue does NOT extend this map — new roles fall back to "slate".
 */
export const ROLE_TONES: Record<string, string> = {
  "Project Manager": "blue",
  "Frontend Developer": "pink",
  "Backend Developer": "navy",
  Analyst: "y",
  Tester: "g",
  UX: "pink",
  DevOps: "slate",
};

export function roleTone(name: string): string {
  return ROLE_TONES[name] ?? "slate";
}
